import React, { useEffect, useContext } from 'react'
import { AuthContext } from '@/layout/Auth'
import { TextField, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Message } from '@cx/ui'
import Modal2 from '@/components/Modal2'
import { dissolveOrg } from '@/api'
import { Text } from './common'
import { Controller, useForm } from 'react-hook-form'

interface DissolutionSpaceModalProps {
  open: boolean
  onCancel: () => void
}

const DissolutionSpaceModal: React.FC<DissolutionSpaceModalProps> = ({ open, onCancel }) => {
  const navigate = useNavigate()
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      code: '',
    },
  })

  const onSubmit = handleSubmit(() => {
    dissolveOrg(orgInfo?.id!).then(() => {
      onCancel()
      navigate('/console/workbench')
      navigate(0)
    })
  })

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open])

  return (
    <Modal2
      title='提示'
      width={625}
      okText='解散'
      okButtonProps={{ color: 'error' }}
      open={open}
      onCancel={onCancel}
      onOk={onSubmit}
    >
      <Text sx={{ fontSize: 14 }}>确认解散此空间？</Text>
      <Text sx={{ fontSize: 14, color: 'error.main', mt: 2, mb: 3 }}>
        解散空间后，该空间所有数据将被一并删除，包括不限于：空间成员，已开通或已购买但未到期的产品应用，站内消息，消息通知策略等。
      </Text>
      <Stack direction='row' alignItems='center' sx={{ fontSize: 14, mt: 2, mb: 1, color: 'rgba(0,0,0,0.5)' }}>
        输入 “<Text sx={{ color: '#000', fontWeight: 500 }}>确认解散</Text>” 以确认操作
      </Stack>
      <Stack gap={3}>
        <Controller
          rules={{
            required: '请输入确认解散',
            validate: (value) => value === '确认解散' || '请输入确认解散',
          }}
          name='code'
          control={control}
          render={({ field }) => (
            <TextField
              required
              placeholder='请输入'
              {...field}
              variant='outlined'
              fullWidth
              error={Boolean(errors.code)}
              helperText={errors.code?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
      </Stack>
    </Modal2>
  )
}

export default DissolutionSpaceModal
